import { useEffect } from 'react';

/**
 * SEO Component - Sets document title dynamically
 * Meta tags are defined in public/index.html for static SEO
 */
const SEO = ({ title = '' }) => {
  const siteName = 'CLOUD IT';
  
  useEffect(() => {
    const fullTitle = title 
      ? `${title} | ${siteName}` 
      : `${siteName} | Custom Web Development & AI Solutions in Buffalo NY`;
    document.title = fullTitle;
    
    // Return the original title on unmount
    return () => {
      document.title = `${siteName} | Custom Web Development & AI Solutions in Buffalo NY`;
    };
  }, [title]);

  // Note: Static SEO meta tags are in public/index.html
  // This component only handles dynamic page titles
  return null;
};

export default SEO;
